// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__3fU3K","content":"Content_content__RKYag"};